// Development environment configuration
export const environment = {
  environment_name: 'dev',
  redirect_url: 'https://dev.aiadvisor.jnj.com',
  client_id: '1cd18367-b798-4d36-8ab0-3413f0cb5945',
  authority: 'https://login.microsoftonline.com/3ac94b33-9135-4821-9502-eafda6592a35',
  api_base_url: 'https://api.dev.medtechai.jnj.com',
  // Empty = same-origin relative `/api/...` calls (matches qa/prod). Requests
  // stay on the UI origin and are resolved in-cluster, so no public host is
  // baked into the bundle.
  microservice_api_base_url: 'https://api.dev.medtechai.jnj.com', //'https://dev.aiadvisor.jnj.com'
};
